import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const mcpRegistryAppBuilder = DataRouterApplicationBuilder.create('mcp-registry')
